module.exports = __webpack_public_path__ + "img/icon-disabled-acc.47a26a04.svg";